import { render, staticRenderFns } from "./VaraSelect.vue?vue&type=template&id=ee8dd9ee"
import script from "./VaraSelect.vue?vue&type=script&lang=js"
export * from "./VaraSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports